import ProducerSelect from 'components/ProducerSelect';

// 商品规格书查询表单校验
export const searchFormRules = {
    preSkuId: [
        {
            type: 'string',
            trigger: 'blur',
            validator: (rule, value, callback) => {
                if (value && !/^\d+$/.test(value)) {
                    callback(new Error('preSkuId应为数字'));
                } else {
                    callback();
                }
            },
        },
    ],
};

// 版本
export const VERSION_SOURCE = {
    V1: 1,
    V2: 2,
};

export const standardVersionList = [
    { label: 'v1', value: VERSION_SOURCE.V1 },
    { label: 'v2', value: VERSION_SOURCE.V2 },
];

// 填写状态 10 待填写， 20 已填写
export const SUPPLIER_SUBMIT_STATE_SOURCE = {
    WAITING: 10,
    SUBMITTED: 20,
};

export const supplierSubmitStateSource = [
    { label: '待填写', value: SUPPLIER_SUBMIT_STATE_SOURCE.WAITING },
    { label: '已填写', value: SUPPLIER_SUBMIT_STATE_SOURCE.SUBMITTED },
];

// 审批状态 40 审核中，50 审核通过， 60 审核驳回
export const SUPPLIER_STATE = {
    SUPPLIER_PENDING: 40,
    SUPPLIER_APPROVED: 50,
    SUPPLIER_REJECTED: 60,
};

// 审批状态
export const supplierStateSource = [
    { label: '审核中', value: SUPPLIER_STATE.SUPPLIER_PENDING },
    { label: '审核通过', value: SUPPLIER_STATE.SUPPLIER_APPROVED },
    { label: '审核驳回', value: SUPPLIER_STATE.SUPPLIER_REJECTED },
];

// 按钮控制枚举 1显示 0隐藏
export const BUTTON_STATUS = {
    HIDE: 0,
    SHOW: 1,
};

// 超期状态 是否超期 1是 0否
export const TIME_OUT_STATUS = {
    NORMAL: 0,
    TIMEOUT: 1,
};
// 允许供应商修改1允许2 不允许
export const SUPPLIER_UPDATE = {
    ALLOW: 1,
    NOT_ALLOW: 2,
};

/** 业态map */
export const YT_MAP = {
    /** 小象业态 */
    XIAOXIANG: 10,
    /** 快乐猴业态 */
    MONKEY: 20,
};

/** 业态展示 */
export const YT_NAME_MAP = {
    [YT_MAP.XIAOXIANG]: '小象',
    [YT_MAP.MONKEY]: '快乐猴',
};

export const updateId = (id) => ((!id || id === -1) ? '-' : id);

export const searchFormFields = [
    {
        label: 'PRESKUID',
        prop: 'preSkuId',
        template: {
            component: 'mc-input',
            attrs: {
                placeholder: '请输入PRESKUID',
            },
        },
    },
    {
        label: '生产商名称',
        prop: 'producerId',
        template: {
            component: ProducerSelect,
            attrs: {
                placeholder: '请选择生产商',
            },
        },
    },
    {
        label: '版本',
        prop: 'standardVersion',
        template: {
            component: 'mc-select',
            attrs: {
                placeholder: '全部',
                clearable: true,
                multiple: true,
                source: standardVersionList,
            },
        },
    },
    {
        label: '填写状态',
        prop: 'supplierSubmitState',
        template: {
            component: 'mc-select',
            attrs: {
                placeholder: '全部',
                clearable: true,
                multiple: true,
                source: supplierSubmitStateSource,
            },
        },
    },
    {
        label: '审核状态',
        prop: 'supplierState',
        template: {
            component: 'mc-select',
            attrs: {
                placeholder: '全部',
                clearable: true,
                multiple: true,
                source: supplierStateSource,
            },
        },
    },
];

export const getDefaultSearchParams = () => ({
    preSkuId: null,
    producerId: '',
    standardVersion: [],
    supplierSubmitState: [],
    supplierState: [],
});


export const columns = [
    {
        label: 'SKUID',
        prop: 'skuId',
        width: 90,
        formatter: (row) => updateId(row.skuId),
    },
    {
        label: 'preSkuId',
        prop: 'preSkuId',
        width: 90,
        formatter: (row) => updateId(row.preSkuId),
    },
    {
        label: '商品规格书编号',
        'min-width': 130,
        prop: 'standardCode',
    },
    {
        label: '商品名称',
        prop: 'skuName',
        slot: 'skuName',
    },
    {
        label: '业态类型',
        prop: 'ytType',
        formatter: (row) => YT_NAME_MAP[row.ytType],
    },
    {
        label: '生产商名称',
        prop: 'producerName',
    },
    {
        label: '版本',
        prop: 'standardVersionName',
        width: 70,
    },
    {
        label: '填写状态',
        prop: 'supplierSubmitState',
        formatter: (row) => supplierSubmitStateSource.find((item) => item.value === row.supplierSubmitState)?.label,
    },
    {
        label: '审核状态',
        prop: 'supplierState',
        formatter: (row) => {
            // 审核状态为10展示
            if (row.supplierState === 10) {
                return '-';
            }
            return supplierStateSource.find((item) => item.value === row.supplierState)?.label;
        },
    },
    {
        label: '超期状态',
        prop: 'timeout',
        slot: 'timeout',
        width: 160,
    },
    {
        label: '操作',
        prop: 'operate',
        width: 170,
    },
];
